import { CLIENT_TOTAL_USERS, CLIENT_TOTAL_USERS_SUCCESS, CLIENT_TOTAL_USERS_ERROR, CLIENT_TOTAL_USERS_EMPTY } from '../../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ClientTotalUsers = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_TOTAL_USERS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CLIENT_TOTAL_USERS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CLIENT_TOTAL_USERS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CLIENT_TOTAL_USERS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ClientTotalUsers;
